import SharedStore from 'shared/stores/shared.store'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { apiClient } from 'utils/requests.utils'

import { EventAttendeesApi, createEventAttendeesApi, EventAttendee } from 'shop/api/eventAttendees.api'
import { AttendeeAssignmentsApi, createAttendeeAssignmentsApi } from 'shop/api/attendeeAssignments.api'

export class EventAttendeesStore extends SharedStore<EventAttendee> {
  storeName = 'EventAttendeesStore'
  declare childApi: EventAttendeesApi
  // Bulk assign is v2. List and single-attendee save are still v1.
  assignmentsApi: AttendeeAssignmentsApi

  constructor(root?: ShopRootStore) {
    super()
    this.childApi = createEventAttendeesApi(root?.apiClient ?? apiClient)
    this.assignmentsApi = createAttendeeAssignmentsApi(root?.apiClientV2)
  }
}

export default new EventAttendeesStore()
